import {
  ListTypeEnum,
  TSessionItem,
  TSessionListGroupTitle,
  TSessionListItem,
} from './type.js';
import intl from '@/internationalzation/intl';
export const groupConversionByTime = (
  data: TSessionItem[],
): Array<TSessionListGroupTitle | TSessionListItem> => {
  const sortedData = data.sort((a, b) => {
    return new Date(b.createTime).getTime() - new Date(a.createTime).getTime();
  });

  const now = new Date();
  const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
  const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);

  const recent7Days: TSessionItem[] = [];
  const recent30Days: TSessionItem[] = [];
  const past: TSessionItem[] = [];

  sortedData.forEach((item) => {
    const itemDate = new Date(item.createTime);
    if (itemDate >= sevenDaysAgo) {
      recent7Days.push(item);
    } else if (itemDate >= thirtyDaysAgo) {
      recent30Days.push(item);
    } else {
      past.push(item);
    }
  });

  // 定义分组配置
  const groups = [
    {
      title: intl.t('mario.filter.last7days'),
      data: recent7Days,
      id: 'recent-7-days',
    },
    {
      title: intl.t('mario.filter.last30days'),
      data: recent30Days,
      id: 'recent-30-days',
    },
    { title: intl.t('mario.filter.past'), data: past, id: 'past' },
  ];
  // 创建拍平的结果数组
  const flatResult: Array<TSessionListGroupTitle | TSessionListItem> = [];
  // 为每个有数据的分组生成标题和列表项
  groups.forEach((group) => {
    if (group.data.length > 0) {
      // 插入分组标题
      flatResult.push({
        type: ListTypeEnum.TITLE,
        title: group.title,
        id: group.id,
      });

      // 插入该分组的所有数据项
      group.data.forEach((item) => {
        flatResult.push({
          type: ListTypeEnum.LIST,
          ...item,
        });
      });
    }
  });
  return flatResult;
};
